const PaginationButton = ({
  index,
  children,
  currentPage,
  onPageChange,
}: {
  index: number;
  children: React.ReactNode;
  currentPage: number;
  onPageChange: (page: number) => void;
}) => {
  // rendering custom pagination button component here
  return (
    <button
      onClick={() => onPageChange(index)}
      className={`border-2 border-legal-brown w-7 h-7 rounded-md font-semibold hover:opacity-55 duration-300 ${
        currentPage === index
          ? 'bg-legal-brown text-legal-dark-blue'
          : ' text-legal-brown'
      }`}
    >
      {children}
    </button>
  );
};

export default PaginationButton;
